// extracted by mini-css-extract-plugin
export default {"container":"SFKc2","notFirstItem":"+H5Ru","pimple":"_9wO0J","pimpleFullButton":"icYJC","pimpleHollowButton":"dU45z","updatedIndicationText":"zO7OB"};